module.exports = __webpack_public_path__ + "static/media/45pic.95570557.jpg";